import getAxiosInstance from '../../../helpers/get_axios_instance'
import { OK } from 'http-status-codes'

export function getListaDeEtiquetas (cereal, cerealVariedad) {
  const axios = getAxiosInstance()
  const promise = axios.get(`/consulta_etiqueta_color_silos?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}"}}`)
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo obtener la lista de etiquetas')
    return (data)
  })
}
